import { Injectable } from '@angular/core';
import { Store, select } from '@ngrx/store';
import { faro } from '@grafana/faro-web-sdk';
import { selectRouteBoardId } from '../../store/router/router.selectors';
import { AppState } from '../../store/store.types';
import { filter } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class TracingService {
  private boardId!: string;

  constructor(private _store: Store<AppState>) {
    this._store
      .pipe(
        select(selectRouteBoardId),
        filter((boardId): boardId is string => !!boardId)
      )
      .subscribe((boardId: string) => {
        this.boardId = boardId;
      });
  }

  trace<T>(spanName: string, callback: () => T): T {
    const isFaroInitialized = !!faro?.api;

    if (!isFaroInitialized) {
      // If faro is not initialized, just run the callback function
      return callback();
    }

    const OTEL = faro.api.getOTEL();

    if (!OTEL) {
      // If OTEL is not initialized, just run the callback function
      return callback();
    }

    const { trace, context } = OTEL;

    if (!this.boardId) {
      // If boardId is not initialized, just run the callback function
      return callback();
    }

    const tracer = trace.getTracer('default');

    const span = tracer.startSpan(spanName, {
      attributes: { boardId: this.boardId },
    });

    return context.with(trace.setSpan(context.active(), span), () => {
      try {
        return callback();
      } finally {
        span.end();
      }
    });
  }
}
